(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ContactManagerFormController', [
            'MW.Framework.InfluencerContactService',
            'MW.ContactManager.ContactManagerNavigationService',
            'MW.ContactManager.ContactManagerPropertyTypeService',
            'MW.Framework.inputCancel',
            'MW.ContactManager.ContactManagerFlashService',
            'MW.Influencers.IcmDialogService',
            'MW.Framework.TranslationService',
            'MW.Framework.CoreUserService',
            'MW.Framework.CoreCompanyService',
            'MW.Influencers.AnalyticsService',
            'MW.CustomValidation',
            'MW.ContactManager.ActiveOnFormDropdown',
            'MW.Framework.PageStateService',
            'MW.Framework.ValidationConstants',
            'MW.Framework.ContentStreamDataFactory',
            'ui.bootstrap'
        ])
        .controller('ContactManagerFormController', [
            'InfluencerContactService',
            'ContactManagerNavigationService',
            'salutationTypes',
            'emailTypes',
            'phoneNumberTypes',
            'addressTypes',
            'activeOnTypes',
            'breadcrumbs',
            'contact',
            'ContactManagerFlashService',
            'ContactManagerUsernameService',
            'DialogService',
            'translationService',
            'CoreUserService',
            'CoreCompanyService',
            'AnalyticsService',
            '$rootScope',
            '$scope',
            '$location',
            '$timeout',
            '$window',
            '$mdDialog',
            '$translate',
            '$q',
            'PageStateService',
            'VALIDATION_CONSTANTS',
            'SourceStreamDataFactory',
            ContactManagerFormController
        ]);

    function ContactManagerFormController(
        InfluencerContactService,
        ContactManagerNavigationService,
        salutationTypes,
        emailTypes,
        phoneNumberTypes,
        addressTypes,
        activeOnTypes,
        breadcrumbs,
        contact,
        ContactManagerFlashService,
        FormValidationService,
        DialogService,
        translationService,
        CoreUserService,
        CoreCompanyService,
        AnalyticsService,
        $rootScope,
        $scope,
        $location,
        $timeout,
        $window,
        $mdDialog,
        $translate,
        $q,
        PageStateService,
        VALIDATION_CONSTANTS,
        SourceStreamDataFactory
    ) {

        this.contact = contact;
        this.breadcrumbs = breadcrumbs;
        this.isSaving = false;
        this.InfluencerContactService = InfluencerContactService;
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.salutationTypes = salutationTypes;
        this.emailTypes = emailTypes;
        this.phoneNumberTypes = phoneNumberTypes;
        this.addressTypes = addressTypes;
        this.activeOnTypes = activeOnTypes;
        this.ContactManagerFlashService = ContactManagerFlashService;
        this.PageStateService = PageStateService;
        this.$timeout = $timeout;
        this.$location = $location;
        this.$scope = $scope;
        this.$q = $q;
        this.DialogService = DialogService;
        this.CoreUserService = CoreUserService;
        this.CoreCompanyService = CoreCompanyService;
        this.AnalyticsService = AnalyticsService;
        this.validateEmailRegex = VALIDATION_CONSTANTS.EMAIL_REGEX;
        this.validatePhoneNumberRegex = VALIDATION_CONSTANTS.PHONE_NUMBER_REGEX;
        this.validateUrlRegex = VALIDATION_CONSTANTS.URL_REGEX;
        this.$window = $window;
        this.$mdDialog = $mdDialog;
        this.$translate = $translate;
        this.activeonChannelCount = 0;

        this.SourceStreamDataFactory = new SourceStreamDataFactory();

        if (this.contact) {
            if (this.contact.channels && 0 === this.contact.channels.length) {
                this.contact.channels.push({type: translationService.getLocalizedString('Twitter')});
            } else {
                this.contact.channels = this.extractSources(this.contact.channels);
            }
            if (this.contact.title && 0 === this.contact.title.length) {
                this.contact.title.push('');
            }
        }

        // Preventing Navigation during editing
        this.onRouteChangeOff = $rootScope.$on('$locationChangeStart', function routeChangeStartEvent(event, nextUrl, prevUrl) {
            var dialogTitle = translationService.getLocalizedString('Leave Page?'),
                dialogContent = translationService.getLocalizedString('You are about to leave the page. Any unsaved changes will be lost.');
            // need to handle navigating within & outside of application
            function continueNavigation() {
                var previousURI= URI(prevUrl),
                    navigateToURI = URI(nextUrl);
                if(previousURI.host() === navigateToURI.host()) {
                    $location.path(navigateToURI.path());
                } else {
                    $window.location.href = navigateToURI.toString();
                }
            }
            if ($scope && $scope.contactForm && $scope.contactForm.$dirty) {
                event.preventDefault();
                if ($scope.contactForm.$invalid) {
                    this.DialogService.confirm(dialogContent, dialogTitle, function confirmLeavePageCallback(result) {
                        // Page leaving with invalid form should not have the save button.
                        if (result.success) {
                            this.onRouteChangeOff();
                            continueNavigation();
                        }
                    }.bind(this));
                } else {
                    this.DialogService.confirmExit(null, null, function confirmExitLeavePageCallback(result) {
                        if (result.success) {
                            if (result.successDetail !== 'abandon') {
                                this.confirmAdd(false, null).then(function() {
                                    this.onRouteChangeOff();
                                    continueNavigation();
                                }.bind(this))
                                .catch(function() {});
                            } else {
                                this.onRouteChangeOff();
                                continueNavigation();
                            }
                        }
                    }.bind(this));
                }
            }

        }.bind(this));

        $scope.$on('toggleDropdownMenuDirective', function() {
            $scope.contactForm.$setDirty();
        });
    }

    ContactManagerFormController.prototype.extractSources = function extractSources(channels) {
        var channelList = [];

        (channels || []).forEach(function(channel) {
            if (channel.type === this.activeOnTypes.SOURCE) {
                channelList.push({
                    'type': channel.type,
                    'source': (!channel.id) ? channel.name : { 'source': channel, 'id':  channel.id, 'name' : channel.name }
                });
            } else {
                channelList.push(channel);
            }
        }.bind(this));

        return channelList;
    };

    ContactManagerFormController.prototype.watchSourceInput = function watchSourceInput(index) {
        this.$scope.$watch(angular.bind(this, function() {
            return this.contact.channels[index].source;
        }), this.getSources);
    };

    ContactManagerFormController.prototype.getSources = function getSources(query) {
        var searchQuery = { q: query, filters: [{'type': 'sourceType', 'values': ['edition']}], aggregations: [], pageSize: 20, page: 0 };
        return this.SourceStreamDataFactory.aggregateSearch(searchQuery)
        .then(function(response) {
            this.sourceAutocompleteList = [];
            (response.hits || []).forEach(function(source) {
                this.sourceAutocompleteList.push({
                    id: source.id,
                    name: source.name,
                    source: source
                });
            }, this);
            return this.sourceAutocompleteList;
        }.bind(this))
            .catch(function() {});
    };

    ContactManagerFormController.prototype.cancel = function cancel() {
        this.onRouteChangeOff();

        if(this.$location.path().indexOf('/influencers/contact/create') > -1){
            this.ContactManagerNavigationService.goToContactAddLanding();
        } else if (this.$location.path().indexOf('/influencers/contact/edit') > -1){
            let pathArray = this.$location.path().split('/');
            this.ContactManagerNavigationService.goToProfileView(pathArray[pathArray.length-1]);
        } else {
            this.ContactManagerNavigationService.goToList();
        }
    };

    ContactManagerFormController.prototype.confirmAdd = function confirmAdd(saveSubmittedForm, ev) {
        if (this.contact.id) {
            // skip for editing contact
            return this.$q.when(this.saveContact(saveSubmittedForm));
        }
        else {
            var confirmMessage = this.$translate.instant('icm-web__data-controller--add-contact-msg'),
            okButton = this.$translate.instant('Ok'),
            cancelButton = this.$translate.instant('Cancel');

            return this.$q(function(resolve) {
                this.$mdDialog.show(
                    this.$mdDialog.mwConfirm()
                        .textContent(confirmMessage)
                        .ok(okButton)
                        .cancel(cancelButton)
                        .targetEvent(ev)
                ).then(
                    () => {
                        return resolve(this.saveContact(saveSubmittedForm));
                    },
                    () => {
                        return resolve();
                    }
                );
            }.bind(this));
        }
    };

    ContactManagerFormController.prototype.saveContact = function saveContact(saveSubmittedForm) {
        var defer = this.$q.defer();
        this.isSaving = true;
        this.InfluencerContactService.saveContact(this.contact).then(function (contactResponse) {
            contactResponse.contact.notes = this.contact.notes;
            this.ContactManagerFlashService.flashSuccess(contactResponse.message);
            this.trackEvent('add_contact');
            if (saveSubmittedForm === true) {
                this.InfluencerContactService.setCurrentContact(contactResponse.contact);
                this.ContactManagerNavigationService.goToProfileView(contactResponse.contact.id);
            }
            defer.resolve();
        }.bind(this))
        .catch(function (err) {
            if(err && err.error && err.error.reason && err.error.reason === 'MISMATCH_COMPANIES'){
                this.$mdDialog.show(
                    this.$mdDialog.mwAlert()
                        .title(this.$translate.instant('icm-contact__create-multi-company-warning-modal--header'))
                        .htmlContent(this.$translate.instant('icm-contact__create-multi-company-warning-modal--body-string-1') + '<br><br>' + this.$translate.instant('icm-contact__create-multi-company-warning-modal--body-string-2'))
                        .ok('OK')
                ).then(() => {
                    this.status = 'Alert Closed';
                });
            } else {
                this.ContactManagerFlashService.flashError(err);
            }
            this.isSaving = false;
            defer.resolve(err);
        }.bind(this))
        .finally(function() {
            this.onRouteChangeOff();
        }.bind(this));
        return defer.promise;
    };

    ContactManagerFormController.prototype.deleteContact = function deleteContact() {
        var self = this;

        this.DialogService.confirm(
            'Are you sure you want to delete the current Contact?',
            'Delete Contact?',
            {
                callback: function deleteContactCallback(details) {
                    // only attempt to delete if user accepted the warning
                    if (details.success) {
                        self.InfluencerContactService.deleteContact(self.contact.id).then(function (response) {
                            self.ContactManagerFlashService.flashSuccess(response.message);
                            self.ContactManagerNavigationService.goToList();
                            self.trackEvent('remove_contact');
                        }).catch(function(err) {
                            self.ContactManagerFlashService.flashError(err);
                        });
                    }
                }
            }
        );
    };

    ContactManagerFormController.prototype.profilePicChanged = function profilePicChanged(profilePic) {
        this.contact.profilePic = profilePic;
    };

    ContactManagerFormController.prototype.addNewRow = function (type, collection) {
        collection.push({type: type});

        if(typeof type === 'undefined') { //A case where activeOn row is added
            this.$timeout(function() {
                this.$window.scrollTo(0, document.body.scrollHeight);
            }.bind(this), 0);
        }
    };

    ContactManagerFormController.prototype.addNewEntryRow = function (collection) {
        collection.push('');
    };

    ContactManagerFormController.prototype.removeItemFromCollection = function removeItemFromCollection(index, collection) {
        collection.splice(index, 1);
        //making form dirty implicitly on deletion of collection
        this.$scope.contactForm.$dirty = true;
    };

    ContactManagerFormController.prototype.activeOnChanged = function activeOnChanged(index, selectedType) {
        this.contact.channels[index] = {
            type: selectedType
        };
    };

    ContactManagerFormController.prototype.trackEvent = function trackEvent(eventName) {
        var promises = [],
            currentUser,
            currentCompany,
            trackingData;

        promises.push(this.CoreUserService.getCurrent(true));
        promises.push(this.CoreCompanyService.getCurrent(true));

        this.$q.all(promises).then(function(responses) {
            currentUser = responses[0];
            currentCompany = responses[1];
            trackingData = {
                source: 'webapp',
                label: eventName,
                mediaListId: 'All Contacts',
                contactCount: 1,
                parentType: 'ICM_contact_lists',
                userId: currentUser.email + ' (' + currentUser._id + ') ' + currentCompany.name
            };
            this.AnalyticsService.trackMediaListOperation(eventName, trackingData);

        }.bind(this));
    };

}());
